import { cloneDeep } from "lodash";

import BaseCommand from "./baseCommand";

class SignatureSignerRemoveCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.preventNukeActiveState = true;
  }

  execute() {
    const { data, index: i, onSectionUpdate, setState } = this.componentData;
    const newData = cloneDeep(data);
    newData[i].signer_email = "";
    newData[i].first_name = "";
    newData[i].last_name = "";
    newData[i].signer_config = { ...newData[i].signer_config };
    newData[i].signer_config.image_url = "";
    newData[i].internalUser = false;
    newData[i].updateProcess = false;
    newData[i].showNameField = false;
    newData[i].notValid = false;
    newData[i].signer_config.signature_type =
      newData[i].signer_config.signature_type;
    newData[i].signer_config.showAuth = false;
    setState(() => ({ signBlocks: newData }));
    onSectionUpdate(newData[i], false, newData);
  }

  undo() {
    const {
      data,
      index: signerIndex,
      onSectionUpdate,
      setState,
    } = this.componentData;
    const newData = cloneDeep(data);
    setState(() => ({ signBlocks: newData }));
    onSectionUpdate(newData[signerIndex], false, newData);
  }
}

export default SignatureSignerRemoveCommand;



// WEBPACK FOOTER //
// ./src/commands/signatureSignerRemovedCommand.js